export const MAX_PHOTO_BYTES = 25 * 1024 * 1024;

const PASTED_IMAGE_EXTENSIONS = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'image/heif': 'heif',
  'image/bmp': 'bmp',
};

const isImage = (file) => Boolean(file?.type?.startsWith('image/'));

/** Returns the error to show for a file that can't be sent as a chat photo, or null when it's fine. */
export const getPhotoFileError = (file) => {
  if (file.type && !isImage(file)) return 'Only photos can be sent.';
  if (file.size > MAX_PHOTO_BYTES) return 'Photos must be 25 MB or smaller.';
  return null;
};

/** Clipboard images are usually named "image.png"; give them a recognisable, unique name. */
export const renamePastedImage = (file, now = Date.now()) => {
  const extension = PASTED_IMAGE_EXTENSIONS[file.type?.toLowerCase()] || 'png';
  return new File([file], `pasted-image-${now}.${extension}`, { type: file.type || 'image/png' });
};

/** Files from a paste's ClipboardData (items first, which Chrome/Safari populate for screenshots). */
export const getClipboardFiles = (clipboardData) => {
  if (!clipboardData) return [];
  const fromItems = Array.from(clipboardData.items || [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile?.())
    .filter(Boolean);
  if (fromItems.length) return fromItems;
  return Array.from(clipboardData.files || []);
};

/** Prefers the first image so a mixed selection still attaches a photo; otherwise the first file (to report why it's rejected). */
export const pickPhotoFile = (files) => files.find(isImage) || files[0] || null;

/** True when a drag carries files (not text or links being dragged around the page). */
export const dragHasFiles = (dataTransfer) => Array.from(dataTransfer?.types || []).includes('Files');
